import produce from 'immer';

import { OAUTH_CLIENT_RECEIVED } from 'constants/actions';

export var INITIAL_STATE = {
  client: null
};

export const oauth = produce((draft, action) => {
  switch (action.type) {
    case OAUTH_CLIENT_RECEIVED:
      return { ...draft, client: action.value };

    default:
      return draft;
  }
}, INITIAL_STATE);

export default oauth;
